module.exports = __webpack_public_path__ + "img/Picture12.c3232331.png";